export default __webpack_public_path__ + "static/media/logo.4830bb08.svg";